import { NgModule } from '@angular/core';
import { RadioGroup } from './radio-group';
import { FormsModule } from '@angular/forms';

@NgModule({
    declarations: [RadioGroup],
    exports: [RadioGroup],
    imports: [FormsModule],
})
export class RadioGroupModule {
}
